<template>
    <div>
       <FilesBrowseModal v-bind="currentProperties"></FilesBrowseModal>
    </div>
</template>

<script>
import FilesBrowseModal from '../files/filesBrowse.vue';
export default {
  name:'fusionbrowsefromblaze',
  components:{
      FilesBrowseModal
  },
 computed:{
    currentProperties() {          
        return {enableAssetMultiSelect:true, enableBinsWorkspace:true, enableCatalogsWorkspace:true,workspaceList:['catalogs','bins']}
     }
  }
}
</script>

<style scoped>

</style>